const TextSliderData02 = [
  {
    img: "https://via.placeholder.com/1050x614",
    title: "Business",
    subtitle: " transformation",
    content:
      "Lorem ipsum dolor consectetur adipiscing mod tempor incididunt labore dolore magna ut veniam.",
    buttonTitle: "Learn more",
    buttonLink: "/page/our-services",
  },
  {
    img: "https://via.placeholder.com/1050x614",
    title: "Strategic",
    subtitle: "communication",
    content:
      "Lorem ipsum dolor consectetur adipiscing mod tempor incididunt labore dolore magna ut veniam.",
    buttonTitle: "Learn more",
    buttonLink: "/page/our-services",
  },
  {
    img: "https://via.placeholder.com/1920x950",
    title: "Competitors",
    subtitle: " research",
    content:
      "Lorem ipsum dolor consectetur adipiscing mod tempor incididunt labore dolore magna ut veniam.",
    buttonTitle: "Learn more",
    buttonLink: "/page/our-services",
  },
  {
    img: "https://via.placeholder.com/1050x614",
    title: "Consumer",
    subtitle: " research",
    content:
      "Lorem ipsum dolor consectetur adipiscing mod tempor incididunt labore dolore magna ut veniam.",
    buttonTitle: "Learn more",
    buttonLink: "/page/our-services",
  },
];


export {TextSliderData02 };
